module.exports = __webpack_public_path__ + "img/value_refund.0ceede5a.png";